module.exports = __webpack_public_path__ + "static/media/cheeseburger.d9ae4080.svg";